import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 512,
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M46 180h45v317c0 8.291 6.709 15 15 15h300c8.291 0 15-6.709 15-15V180h45c8.291 0 15-6.709 15-15s-6.709-15-15-15H46c-8.291 0-15 6.709-15 15s6.709 15 15 15m135 272c0 8.291-6.709 15-15 15s-15-6.709-15-15V210c0-8.291 6.709-15 15-15s15 6.709 15 15zm90 0c0 8.291-6.709 15-15 15s-15-6.709-15-15V210c0-8.291 6.709-15 15-15s15 6.709 15 15zm90 0c0 8.291-6.709 15-15 15s-15-6.709-15-15V210c0-8.291 6.709-15 15-15s15 6.709 15 15zm90-377c0-8.291-6.709-15-15-15H331V15c0-8.291-6.709-15-15-15H196c-8.291 0-15 6.709-15 15v45H76c-8.291 0-15 6.709-15 15v45h390zM211 30h90v30h-90z" })
});
export default SvgRemove;
